module.exports = __webpack_public_path__ + "img/slideTwo.78758c61.svg";